
export class File {
  id: number;
  name: string;
  type: FileType;
  length?: number;
  checked?: boolean;
  fileMd5: string;

  static emptyFileName = 'empty-file';

  isVideo(): boolean {
    return this.type == FileType.VIDEO;
  }

  isImage(): boolean {
    return this.type == FileType.IMAGE;
  }
}

export enum FileType {
  VIDEO = 0,
  IMAGE = 1
}
